<template>
  <div style="width: 100%">
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-toolbar flat>
            <v-toolbar-title>
              <h2 class="title primary--text text--darken-1 text-no-wrap mt-0">
                FILTROS
              </h2>
            </v-toolbar-title>
          </v-toolbar>
        </v-row>
        <v-row>
          <select-multiple-unidades
            v-model="unidades"
            :mapeamento-id="diagnostico.mapeamento.id"
          />
        </v-row>
        <v-row
          v-if="
            desempenhoUnidades &&
              desempenhoUnidades.notaAgrupada > 0 &&
              unidades.selecionado.length > 0
          "
        >
          <v-col>
            <v-row>
              <v-toolbar flat>
                <v-toolbar-title>
                  <h2
                    class="title primary--text text--darken-1 text-no-wrap mt-0"
                  >
                    {{
                      `INDICAÇÕES DE TALENTOS E DE DESENVOLVIMENTO ${unidadesSeleciondas}`
                    }}
                  </h2>
                </v-toolbar-title>
              </v-toolbar>
            </v-row>
            <v-row class="justify-center">
              <v-col
                cols="8"
                md="8"
                sm="12"
              >
                <app-indicacao
                  :indicacoes-desenvolvimento="indicacoesDesenvolvimento"
                  :indicacoes-talento="indicacoesTalento"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-toolbar flat>
                <v-toolbar-title>
                  <h2
                    class="title primary--text text--darken-1 text-no-wrap mt-0"
                  >
                    {{ `GRÁFICOS ${unidadesSeleciondas}` }}
                  </h2>
                </v-toolbar-title>
              </v-toolbar>
            </v-row>
            <v-row
              ref="graficos"
              class="justify-center"
            >
              <v-col cols="12">
                <gauge-chart
                  :dados="graficos.gauge.dados"
                  :descricao="`Média da(s) unidade(s) ${unidadesSeleciondas}`"
                  :fonte="`Fonte: Sistema Desenvolva, ${anoDiagnostico}`"
                  :maximo="desempenhoUnidades.notaMaxima * 10"
                  :minimo="0"
                  :titulo="tituloGrafico"
                  class="chart"
                  descricao-titulo="Resultado Comportamental da(s) Unidade(s)"
                  formato="%"
                  :is-get-svg="isGetSvg"
                  @svg="(value) => svg = value"
                />
              </v-col>
              <v-col cols="12">
                <p class="caption text-center">
                  {{ legendaUnidadesInviabilizadas }}
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-data-table
                  :headers="headers"
                  :items="desempenhoUnidades.resultadosComportamentais"
                  :items-per-page="-1"
                  :search="opcoes.pesquisa"
                  :sort-by="opcoes.ordenarPor"
                  :sort-desc="opcoes.decrescente"
                  class="elevation-0"
                  disable-pagination
                  hide-default-footer
                  item-key="competencia.id"
                  show-expand
                  single-expand
                >
                  <template v-slot:top>
                    <v-row>
                      <v-toolbar flat>
                        <v-toolbar-title>
                          <h2
                            class="
                              title
                              primary--text
                              text--darken-1 text-no-wrap
                            "
                          >
                            {{ `RESULTADOS (${unidadesViabilizadas})` }}
                          </h2>
                        </v-toolbar-title>
                      </v-toolbar>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <app-sort v-model="opcoes" />
                      </v-col>
                      <v-spacer />
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <app-search v-model="opcoes" />
                      </v-col>
                    </v-row>
                  </template>
                  <template
                    v-slot:[`item.data-table-expand`]="{
                      item,
                      expand,
                      isExpanded,
                    }"
                  >
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          height="100%"
                          text
                          width="100%"
                          @click="expand(!isExpanded)"
                          v-on="on"
                        >
                          <v-badge right>
                            <template v-slot:badge>
                              <span>{{ item.resultadosUnidade.length }}</span>
                            </template>
                            <v-icon
                              color="grey lighten-0"
                              large
                            >
                              account_balance
                            </v-icon>
                          </v-badge>
                        </v-btn>
                      </template>
                      <span>Clique para exibir os resultados das unidades</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td
                      :colspan="headers.length"
                      class="justify-center"
                    >
                      <v-row dense>
                        <v-spacer />
                        <v-col>
                          <v-row class="justify-center">
                            <h2
                              class="
                                title
                                primary--text
                                text--darken-1 text-no-wrap
                              "
                            >
                              UNIDADES
                            </h2>
                          </v-row>
                        </v-col>
                        <v-spacer />
                      </v-row>
                      <v-row>
                        <v-spacer />
                        <v-col cols="10">
                          <v-simple-table class="elevation-0 mb-4">
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">
                                    NOME DA UNIDADE
                                  </th>
                                  <th class="text-center">
                                    SIGLA DA UNIDADE
                                  </th>
                                  <th class="text-center">
                                    MÉDIA DA UNIDADE
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="resultado in item.resultadosUnidade"
                                  :key="resultado.unidade.id"
                                >
                                  <td>
                                    <span class="grey--text text--darken-2">{{
                                      resultado.unidade.nome
                                    }}</span>
                                  </td>
                                  <td
                                    class="text-center"
                                    width="15%"
                                  >
                                    <span class="grey--text text--darken-2">{{
                                      resultado.unidade.sigla
                                    }}</span>
                                  </td>
                                  <td
                                    class="text-center"
                                    width="15%"
                                  >
                                    <span class="grey--text text--darken-2">{{
                                      resultado.notaAgrupada | decimal
                                    }}</span>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-col>
                        <v-spacer />
                      </v-row>
                    </td>
                  </template>
                  <template v-slot:[`item.notaMaxima`]="{ item }">
                    {{ item.notaMaxima | decimal }}
                  </template>
                  <template v-slot:[`item.notaAgrupada`]="{ item }">
                    {{ item.notaAgrupada | decimal }}
                  </template>
                  <template v-slot:[`item.desvioPadrao`]="{ item }">
                    {{ getDesvioPadrao(item.resultadosUnidade) | decimal }}
                  </template>
                  <template v-slot:[`body.append`]>
                    <tr>
                      <td
                        align="center"
                        colspan="2"
                      >
                        <strong
                          class="subtitle-2 grey--text text--darken-2"
                        >TOTAL</strong>
                      </td>
                      <td align="center">
                        <strong>{{
                          desempenhoUnidades.notaMaxima | decimal
                        }}</strong>
                      </td>
                      <td align="center">
                        <strong>{{
                          desempenhoUnidades.notaAgrupada | decimal
                        }}</strong>
                      </td>
                      <td align="center">
                        <strong>{{ totalDesvioPadrao | decimal }}</strong>
                      </td>
                    </tr>
                    <v-divider />
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row
              v-if="
                desempenhoUnidades &&
                  desempenhoUnidades.unidadesInviabilizadas.length > 0
              "
            >
              <v-col>
                <v-data-table
                  :headers="headersInviabilizados"
                  :items="desempenhoUnidades.unidadesInviabilizadas"
                  :items-per-page="-1"
                  class="elevation-0"
                  disable-pagination
                  hide-default-footer
                  item-key="id"
                >
                  <template v-slot:top>
                    <v-row>
                      <v-toolbar flat>
                        <v-toolbar-title>
                          <h2
                            class="
                              title
                              primary--text
                              text--darken-1 text-no-wrap
                            "
                          >
                            {{
                              `DESEMPENHOS COMPORTAMENTAIS INVIABILIZADOS (${unidadesInviabilizadas})`
                            }}
                          </h2>
                        </v-toolbar-title>
                      </v-toolbar>
                    </v-row>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row class="justify-end mb-1">
              <v-tooltip
                max-width="400"
                top
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-4"
                    color="success"
                    @click="getRelatorio(desempenhoUnidades)"
                    v-on="on"
                  >
                    <v-icon>get_app</v-icon>
                    BAIXAR PDF
                  </v-btn>
                </template>
                <span>Clique para baixar o relatório dos dados em formato PDF.</span>
              </v-tooltip>
            </v-row>
          </v-col>
        </v-row>
        <v-row
          v-else-if="
            desempenhoUnidades &&
              desempenhoUnidades.notaAgrupada === 0 &&
              unidades.selecionado.length > 0
          "
        >
          <v-col>
            <app-alert
              icon="info"
              message="Não há desempenhos viabilizados na(s) unidade(s)."
              type="info"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { std } from 'mathjs';
import AppAlert from '@/components/core/AppAlert';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import AppIndicacao from '@/components/core/AppIndicacaoComportamental';
import GaugeChart from '@/components/chart/GaugeChart';
import SelectMultipleUnidades from '@/components/SelectMultipleUnidades';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import { generatePDF, preparePdf, convertSvg } from '@/modules/relatorioPDF';
import Data from '@/modules/data';
import toDecimal from '@/filters/decimal';

const desempenhoRepository = RepositoryFactory.get('desempenho');

export default {
  name: 'RelatorioGerencialComportamental',

  components: {
    AppAlert,
    AppSort,
    AppSearch,
    SelectMultipleUnidades,
    AppIndicacao,
    GaugeChart,
  },

  props: {
    diagnostico: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      desempenhoUnidades: null,
      unidades: {
        isTodasSelecionadas: null,
        selecionado: [],
        visualizacao: '',
      },
      headers: [
        { text: 'COMPETÊNCIA', value: 'competencia.nome', sortable: false },
        {
          text: 'UNIDADES',
          value: 'data-table-expand',
          width: '10%',
          align: 'center',
        },
        {
          text: 'RESULTADO MÁXIMO',
          value: 'notaMaxima',
          width: '15%',
          sortable: false,
          align: 'center',
        },
        {
          text: 'MÉDIA DA UNIDADE',
          value: 'notaAgrupada',
          width: '15%',
          sortable: false,
          align: 'center',
        },
        {
          text: 'DESVIO PADRÃO DA UNIDADE',
          value: 'desvioPadrao',
          width: '15%',
          sortable: false,
          align: 'center',
        },
      ],
      headersInviabilizados: [
        { text: 'NOME DA UNIDADE', value: 'nome', sortable: false },
        {
          text: 'SIGLA DA UNIDADE',
          value: 'sigla',
          width: '20%',
          align: 'center',
        },
      ],
      opcoes: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'competencia.nome',
        selecionado: { id: 'competencia.nome', descricao: 'Competência' },
        lista: [
          { id: 'competencia.nome', descricao: 'Competência' },
          { id: 'resultadosUnidade.length', descricao: 'Unidades' },
          { id: 'notaMaxima', descricao: 'Resultado Máximo' },
          { id: 'notaAgrupada', descricao: 'Média da Unidade' },
        ],
      },
      graficos: {
        gauge: { dados: [] },
      },
      isGetSvg: false,
      svg: null,
    };
  },

  computed: {
    unidadesSeleciondas() {
      return this.unidades.visualizacao;
    },
    unidadesViabilizadas() {
      const us = this.unidades.selecionado.filter(
        (u) => !this.desempenhoUnidades.unidadesInviabilizadas.some((u2) => u2.id === u.id),
      );

      if (us.length === this.unidades.selecionado) {
        return '(TODAS)';
      }

      return us.map((u) => u.sigla).join(', ');
    },
    unidadesInviabilizadas() {
      return this.desempenhoUnidades.unidadesInviabilizadas.map((u) => u.sigla).join(', ');
    },
    legendaUnidadesInviabilizadas() {
      if (this.desempenhoUnidades.unidadesInviabilizadas.length > 1) {
        return `* As unidades ${this.unidadesInviabilizadas} não possuem resultado viabilizado.`;
      }
      if (this.desempenhoUnidades.unidadesInviabilizadas.length === 1) {
        return `* A unidade ${this.unidadesInviabilizadas} não possui resultado viabilizado.`;
      }
      return '';
    },
    anoDiagnostico() {
      return this.diagnostico ? this.diagnostico.ano : '';
    },
    indicacoesTalento() {
      if (this.desempenhoUnidades) {
        return this.desempenhoUnidades.resultadosComportamentais.filter((r) => r.indicacaoTalento);
      }
      return [];
    },
    indicacoesDesenvolvimento() {
      if (this.desempenhoUnidades) {
        return this.desempenhoUnidades.resultadosComportamentais.filter((r) => r.indicacaoDesenvolvimento);
      }
      return [];
    },
    tituloGrafico() {
      if (this.unidades.selecionado.length > 1) {
        let titulo = `Resultado Médio Comportamental das Unidades ${this.unidadesSeleciondas}`;
        if (this.desempenhoUnidades && this.desempenhoUnidades.unidadesInviabilizadas.length > 0) {
          titulo += ' *';
        }
        return titulo;
      }
      return `Resultado Médio Comportamental da ${this.unidadesSeleciondas}`;
    },
    totalDesvioPadrao() {
      return this.desempenhoUnidades.resultadosComportamentais.reduce(
        (acumulador, resultado) => acumulador + this.getDesvioPadrao(resultado.resultadosUnidade),
        0,
      );
    },
  },

  watch: {
    diagnostico() {
      this.loadResultado();
    },
    'unidades.selecionado': function () {
      this.loadResultado();
    },
  },

  methods: {
    loadResultado() {
      if (this.unidades.selecionado.length > 0) {
        const unidadesIds = this.unidades.selecionado.map((u) => u.idVersao);
        desempenhoRepository.getByUnidades(this.diagnostico.id, unidadesIds).then((response) => {
          this.desempenhoUnidades = response.data;
          this.graficos.gauge.dados.splice(0);
          this.graficos.gauge.dados.push(parseFloat((this.desempenhoUnidades.notaAgrupada * 10).toFixed(2)));
        });
      }
    },
    getDesvioPadrao(resultadosUnidade) {
      if (resultadosUnidade.length > 0) {
        return std(resultadosUnidade.map((r) => r.notaAgrupada));
      }
      return 0;
    },
    async getRelatorio(desempenho) {
      this.isGetSvg = true;
      await preparePdf(async () => {
        const inicio = Data.format(desempenho.diagnostico.inicioComportamental);
        const fim = Data.format(desempenho.diagnostico.fimComportamental);

        const documento = {
          nome: `relatorio-monitoramento-desempenho-comportamental-geral-${desempenho.diagnostico.id}`,
          cabecalho: {
            titulo: 'Desempenho Comportamental Geral',
            itens: [
              `Diagnóstico: ${desempenho.diagnostico.nome}`,
              `Período de Avaliação: ${inicio} a ${fim}`,
              `Unidades Viabilizadas: ${this.unidadesViabilizadas}`,
              `Unidade Inviabilizadas: ${this.unidadesInviabilizadas}`,
            ],
          },
          blocos: [
            {
              titulo: 'INDICAÇÕES DE TALENTO E DESENVOLVIMENTO',
              itens: [{
                tipo: 'tabela',
                valor: {
                  simples: true,
                  colunas: [
                    'COMPETÊNCIA',
                    'RESULTADO',
                    'RESULTADO\nMÁXIMO',
                    'TIPO DE\nINDICAÇÃO',
                  ],
                  linhas: [
                    ...this.indicacoesTalento.map((i) => [
                      i.competencia.nome,
                      toDecimal(i.notaAgrupada),
                      toDecimal(i.notaMaxima),
                      'Talento',
                    ]),
                    ...this.indicacoesDesenvolvimento.map((i) => [
                      i.competencia.nome,
                      toDecimal(i.notaAgrupada),
                      toDecimal(i.notaMaxima),
                      'Desenvolvimento',
                    ]),
                  ],
                  customizacoes: [
                    {
                      secao: 'body',
                      colunas: [1],
                      estilos: [
                        {
                          cor: 'success',
                          valores: this.indicacoesTalento.map((i) => i.competencia.nome),
                        },
                        {
                          cor: 'error',
                          valores: this.indicacoesDesenvolvimento.map((i) => i.competencia.nome),
                        },
                      ],
                    },
                  ],
                },
              }],
            },
            {
              titulo: 'GRÁFICOS',
              itens: [
                { tipo: 'imagem', valor: await convertSvg(this.svg), largura: 140 },
              ],
            },
            {
              titulo: 'RESULTADOS DAS UNIDADES VIABILIZADAS',
              itens: [{
                tipo: 'tabela',
                valor: {
                  colunas: ['COMPETÊNCIA', 'RESULTADO\nMÁXIMO', 'MÉDIA DA\nUNIDADE', 'DESVIO\nPADRÃO DA\nUNIDADE'],
                  linhas: desempenho.resultadosComportamentais.map((r) => [
                    r.competencia.nome,
                    toDecimal(r.notaMaxima),
                    toDecimal(r.notaAgrupada),
                    toDecimal(this.getDesvioPadrao(r.resultadosUnidade)),
                  ]),
                  rodape: [
                    'TOTAL',
                    toDecimal(desempenho.notaMaxima),
                    toDecimal(desempenho.notaAgrupada),
                    toDecimal(this.totalDesvioPadrao),
                  ],
                },
              }],
            },
          ],
        };
        generatePDF(documento);
      });
      this.isGetSvg = false;
    },
  },
};
</script>

<style scoped>
.chart {
  width: 100%;
  max-height: 400px;
  font-family: Roboto, sans-serif;
}
</style>
